export class ParamTimeDependentState {
  constructor(param) {
    this.param = param;
  }
  active() {
    const frame_graph_node_id = this.param.scene().timeController.graphNode.graphNodeId();
    return this.param.graphPredecessorIds().includes(frame_graph_node_id);
  }
}
